export default {
  noLicensedsAvailable: 'Nenhuma clínica credenciada',
}
